<main class="conversations-page flex h-full min-h-0 w-full min-w-0 flex-col overflow-hidden text-ink">
  <section
    class="conversation-workspace grid min-h-0 flex-1 overflow-hidden"
    [class.conversation-workspace--filters-pinned]="filters.filtersPinned()"
    [class.conversation-workspace--details-open]="filters.detailsOpen()"
    [class.conversation-workspace--no-selection]="!store.hasSelectedConversation()"
    [class.conversation-workspace--mobile-list]="mobileListVisible()"
  >
    <app-conversation-filter-rail
      class="min-h-0"
      [class.filter-rail--pinned]="filters.filtersPinned()"
      [class.filter-rail--expanded]="filters.filtersExpanded()"
      aria-label="Filtros de conversas"
      (pointerenter)="filters.openFiltersPreview()"
    />

    <app-conversation-list class="min-h-0" aria-label="Conversas ativas" (conversationSelected)="openConversation()" />

    <div class="conversation-thread-shell min-h-0">
      <button
        appUiIconButton
        class="conversation-mobile-back"
        variant="ghost"
        size="sm"
        type="button"
        aria-label="Voltar para conversas"
        (click)="showConversationList()"
      >
        <ng-icon name="heroArrowLeft" size="17" aria-hidden="true" />
      </button>
      <app-conversation-thread class="min-h-0" aria-label="Histórico da conversa" />
    </div>

    @if (store.hasSelectedConversation()) {
      <app-conversation-details-panel
        class="min-h-0"
        [class.details-panel--open]="filters.detailsOpen()"
        aria-label="Detalhes da conversa"
      />
    }
  </section>
</main>
